module.exports = __webpack_public_path__ + "media/images/zsenie-2f513f16.png";